var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
var CardGrid = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: grid;\n  grid-template-columns: repeat(auto-fill, 250px);\n  grid-auto-rows: 350px;\n  padding: 1rem;\n  grid-gap: 1rem;\n"], ["\n  display: grid;\n  grid-template-columns: repeat(auto-fill, 250px);\n  grid-auto-rows: 350px;\n  padding: 1rem;\n  grid-gap: 1rem;\n"])));
var CardContainer = function (_a) {
    var children = _a.children;
    return React.createElement(CardGrid, null, children);
};
export default CardContainer;
var templateObject_1;
